/**
 * FosterUI Native Reviews - Judge.me Review Submission Handler
 * Version: 3.0 (Product-Linked Reviews)
 * Purpose: Redirect to Judge.me's hosted review form with correct product context
 * Performance: 0ms TBT (no script loading, direct navigation)
 *
 * IMPLEMENTATION NOTE: Judge.me does not expose an openForm() API.
 * Reviews must be submitted via their hosted form URL.
 *
 *.V3.0 UPDATE: Changed from store-level reviews to product-linked reviews
 * to enable automatic webhook sync. Reviews now include product_external_id.
 */

(function () {
  'use strict';

  console.log('[FosterUI] Native Reviews Engine: Initialized (Product-Linked Mode v3.0)');

  // Store UUID from Judge.me Settings > Request Reviews > Links
  const STORE_UUID = 'f67d84e6-e325-4831-b25b-99db1f547c44';

  /**
   * Extract product ID from the current page context
   * Attempts multiple detection methods for robustness
   */
  function getProductId() {
    // Method 1: From meta tag (most reliable for Shopify)
    const productMeta = document.querySelector('meta[property="og:product:id"]');
    if (productMeta) {
      return productMeta.content;
    }

    // Method 2: From Shopify global object
    if (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product) {
      return String(window.ShopifyAnalytics.meta.product.id);
    }

    // Method 3: From product JSON in script tag (common pattern)
    const productJsonScript = document.querySelector('script[type="application/json"][data-product-json]');
    if (productJsonScript) {
      try {
        const productData = JSON.parse(productJsonScript.textContent);
        if (productData.id) return String(productData.id);
      } catch (e) {
        console.warn('[FosterUI] Could not parse product JSON');
      }
    }

    // Method 4: From product form (fallback)
    const productForm = document.querySelector('form[action*="/cart/add"]');
    if (productForm) {
      const productIdInput = productForm.querySelector('input[name="id"], input[name="product-id"]');
      if (productIdInput) {
        // This is usually variant ID, but can work as fallback
        return productIdInput.value;
      }
    }

    // Method 5: From data attribute on review section
    const reviewSection = document.querySelector('[data-product-id]');
    if (reviewSection) {
      return reviewSection.dataset.productId;
    }

    return null;
  }

  /**
   * Construct Judge.me review submission URL
   *
   * For PRODUCT reviews (enables webhook sync):
   * Format: https://judge.me/product_reviews/[STORE_UUID]/new?id=[PRODUCT_ID]
   *
   * Fallback to STORE reviews if product ID not found:
   * Format: https://judge.me/product_reviews/[STORE_UUID]/new?store-review-only=true
   */
  function buildReviewUrl() {
    console.log('[FosterUI] === Building Review URL (Product-Linked v3.0) ===');

    const productId = getProductId();

    let reviewUrl;
    if (productId) {
      // Product-specific review URL (preferred - enables webhook sync)
      // Judge.me expects product ID as query parameter, not path segment
      reviewUrl = `https://judge.me/product_reviews/${STORE_UUID}/new?id=${productId}&source=fosterui-native`;
      console.log('[FosterUI] Product ID detected:', productId);
      console.log('[FosterUI] Mode: Product-Linked Review (Webhook Sync Enabled)');
    } else {
      // Fallback to store-level review (user must select product)
      reviewUrl = `https://judge.me/product_reviews/${STORE_UUID}/new?store-review-only=true&source=fosterui-native`;
      console.log('[FosterUI] Product ID NOT found - using store-level fallback');
      console.log('[FosterUI] Mode: Store-Level Review (Manual Sync Required)');
    }

    console.log('[FosterUI] Review URL:', reviewUrl);
    console.log('[FosterUI] === URL Construction Complete ===');

    return reviewUrl;
  }

  /**
   * Handle "Write a Review" button clicks
   */
  function handleReviewButtonClick(event) {
    const button = event.target.closest('.write-review-btn');
    if (!button) return;

    // Visual feedback
    const originalText = button.textContent;
    button.textContent = 'REDIRECTING...';
    button.disabled = true;

    try {
      const reviewUrl = buildReviewUrl();

      if (!reviewUrl) {
        throw new Error('Could not construct review URL');
      }

      // Track event for analytics
      if (window.FosterUILab && window.FosterUILab.trackEvent) {
        window.FosterUILab.trackEvent('review_submission_click', {
          product_path: window.location.pathname,
        });
      }

      // Open Judge.me review form in new tab
      console.log('[FosterUI] Opening review form in new tab...');
      const newWindow = window.open(reviewUrl, '_blank', 'noopener,noreferrer');

      // Check if popup was blocked
      if (!newWindow || newWindow.closed || typeof newWindow.closed === 'undefined') {
        console.warn('[FosterUI] Popup blocked by browser.');
        button.textContent = 'POPUP BLOCKED - ALLOW POPUPS';

        // Auto-reset after 3 seconds
        setTimeout(() => {
          button.textContent = originalText;
          button.disabled = false;
        }, 3000);
      } else {
        console.log('[FosterUI] Review form opened successfully.');

        // Reset button immediately
        button.textContent = originalText;
        button.disabled = false;
      }
    } catch (error) {
      console.error('[FosterUI Reviews]', error);
      button.textContent = 'ERROR - SEE CONSOLE';
      button.disabled = false;

      // Reset after 3 seconds
      setTimeout(() => {
        button.textContent = originalText;
      }, 3000);
    }
  }

  // Event delegation for dynamic buttons
  document.addEventListener('click', function (event) {
    if (event.target.closest('.write-review-btn')) {
      event.preventDefault();
      handleReviewButtonClick(event);
    }
  });

  // Expose for debugging
  window.FosterUIReviews = {
    buildReviewUrl: buildReviewUrl,
    getProductId: getProductId,
    version: '3.0-ProductLinked',
  };
})();
